package com.arena_web.data.dto

import kotlinx.serialization.Serializable

@Serializable
data class EventMediaDto(
    val id: String,
    val eventId: String,
    val uploaderId: String,
    val url: String,
    val mediaType: String,
    val fileName: String,
    val fileSize: Long,
    val mimeType: String,
    val isFavorite: Boolean = false,
    val createdAt: String,
    val updatedAt: String
)
